import { render, staticRenderFns } from "./event.vue?vue&type=template&id=58a3f20c&lang=pug&"
import script from "./event.vue?vue&type=script&setup=true&lang=js&"
export * from "./event.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./event.vue?vue&type=style&index=0&id=58a3f20c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports